import React from "react";
import { useTranslation } from "react-i18next";
import { Facebook, Instagram, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation();
  // const [showAdminLogin, setShowAdminLogin] = useState(false);

  // const handleAdminClick = (e) => {
  //   e.preventDefault();
  //   setShowAdminLogin(!showAdminLogin);
  // };

  return (
    <footer className="footer">
      <div className="footer-top">
        <section className="footer-info">
          <h3 className="about-link">
            <Link to="/aboutUs">
              {t("footer.learnMore")}{" "}
              <ArrowRight
                size={14}
                style={{ marginLeft: "6px" }}
              />
            </Link>
          </h3>
          <p className="trusted-since">{t("trusted_since")}</p>
          {/* <button
            onClick={handleAdminClick}
            className="admin-link"
          >
            {t("admin_login")}
          </button> */}
        </section>

        <section className="footer-sections-right">
          <div className="footer-section">
            <h3>{t("follow_us")}</h3>
            <ul className="social-media-links">
              <li className="social-media-link">
                <a
                  href="https://www.facebook.com/share/g/1AFqzn3Q8Q/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit our Facebook profile"
                >
                  <Facebook size={50} />
                </a>
              </li>
              <li className="social-media-link">
                <a
                  href="https://www.instagram.com/globalchicclub/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit our Instagram profile"
                >
                  <Instagram size={50} />
                </a>
              </li>
              <li className="social-media-link">
                <a
                  href="https://t.me/globalchicclub"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Visit our Telegram channel"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </section>
      </div>

      {/* {showAdminLogin && (
        <div className="admin-login-container">
          <AdminLogin />
        </div>
      )} */}

      <div className="footer-legal">
        <nav>
          <Link to="/privacy-policy">{t("footer.privacyPolicy")} &</Link>
          <Link to="/terms-of-use"> {t("footer.termsOfUse")}</Link>
        </nav>
        <p>{t("footer.copyright")}</p>
      </div>

      <div className="footer-bottom">
        <a
          href="https://www.klavalike.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Made by K Bolshakova
        </a>
      </div>
    </footer>
  );
}

export default Footer;
